import { CalculatorControls } from './calculator-controls/calculator-controls';
import { DataChartPanel } from './data-chart-panel/data-chart-panel';
import { HeroSummary } from './hero-summary/hero-summary';
import './savings-calculator.scss';
import { StartSavingNow } from './start-saving-now/start-saving-now';
import { AboutCalculations } from './totals-panel/about-calculations-info-button';
import { TotalsPanel } from './totals-panel/totals-panel';

export const SavingsCalculator = () => (
    <div className="calculator-grid">
        <div className="grid-hero">
            <HeroSummary />
        </div>
        <div className="grid-inputs">
            <CalculatorControls />
        </div>
        <div className="grid-compare">
            <AboutCalculations />
        </div>
        <div className="grid-results-panel">
            <DataChartPanel />
        </div>
        <div className="grid-result">
            <TotalsPanel />
        </div>
        <div className="grid-start-saving">
            <StartSavingNow />
        </div>
    </div>
);
